import { ApiShopperLandingPage } from '@storefronts/common-types'
import Script from 'next/script'
import { useEffect } from 'react'
import type { LandingPageModel } from '../../../models/landingPageModel'
import { PlaylistPlayerVideo } from '../../types'
import { markVendorReady, runWhenReady } from './pixelRuntime'

export class KlaviyoLogger {
    private static klaviyo: any | null = null
    public static init() {
        if (window.klaviyo) {
            KlaviyoLogger.klaviyo = window.klaviyo
        } else {
            KlaviyoLogger.klaviyo = null
        }
    }

    private static logEvent(eventName: string, event: { [key: string]: any }) {
        runWhenReady('klaviyo', () => {
            KlaviyoLogger.init()
            if (!KlaviyoLogger.klaviyo) return
            KlaviyoLogger.klaviyo.track(eventName, event)
        })
    }

    public static TrackVLPImpression(landingPage: LandingPageModel) {
        KlaviyoLogger.logEvent('Viddy Video Landing Page View', {
            vlp_name: landingPage.name,
            current_url: window.location.href,
            vlp_title: landingPage.title,
        })
    }

    public static TrackVideo10SecondView(video: PlaylistPlayerVideo) {
        KlaviyoLogger.logEvent('Viddy Video 10 Second View', {
            video_name: video.name,
            playlist_name: video.playlistName,
        })
    }

    public static TrackVideo6SecondView(video: PlaylistPlayerVideo) {
        KlaviyoLogger.logEvent('Viddy Video 6 Second View', {
            video_name: video.name,
            playlist_name: video.playlistName,
        })
    }
}

const KlaviyoLoggerInitializer: React.FC = () => {
    useEffect(() => {
        KlaviyoLogger.init()
    }, [])
    return null
}

export const KlaviyoPixel: React.FC<{ landingPage: ApiShopperLandingPage }> = ({
    landingPage,
}) => {
    if (!landingPage.integrations.klaviyoId) return null

    return (
        <>
            <Script
                id="klaviyo-pixel"
                strategy="afterInteractive"
                src={`https://static.klaviyo.com/onsite/js/klaviyo.js?company_id=${landingPage.integrations.klaviyoId}`}
                onReady={() => {
                    KlaviyoLogger.init()
                    markVendorReady('klaviyo')
                }}
            ></Script>
            <KlaviyoLoggerInitializer />
        </>
    )
}
